import {useAppContext} from "../../utils/AppContext";
import {motion} from "motion/react"

const Hero = () => {
    const {
        projectData,
        screenSize,
        handleSectionClick,
    } = useAppContext();

    // Styles Configuration //
    const heroContainer = (!screenSize)? "hero-container" : `hero-container hero-container${screenSize}`;
    const proofTextContainer = (!screenSize)? "proof-text-container" : `proof-text-container proof-text-container${screenSize}`;
    const smallTextLight = (!screenSize)? "small-text-light" : `small-text-light small-text-light${screenSize}`;
    const titleContainer = (!screenSize) ? "title-container" : `title-container title-container${screenSize}`;
    const heroTitle = (!screenSize)? "hero-title" : `hero-title hero-title${screenSize}`;
    const largeTextLight = (!screenSize) ? "large-text-light" : `large-text-light large-text-light${screenSize}`;
    const heroCtaContainer = (!screenSize) ? "hero-cta-container" : `hero-cta-container hero-cta-container${screenSize}`;
    const heroButtonsContainer = (!screenSize) ? "hero-buttons-container" : `hero-buttons-container hero-buttons-container${screenSize}`;
    const primaryButton = (!screenSize) ? "primary-button" : `primary-button primary-button${screenSize}`;
    const primaryButtonText = (!screenSize) ? "primary-button-text" : `primary-button-text primary-button-text${screenSize}`;

    return (
        <motion.div
            initial={{opacity: 0}}
            whileInView={{opacity: 1}}
            transition={{duration: 0.9}}
        >
            <div className={heroContainer}>
                <div className={proofTextContainer}>
                    <span className={smallTextLight}>{projectData.hero.proof_snippet}</span>
                </div>
                <div className={titleContainer}>
                    <h1 className={heroTitle}>{projectData.hero.title}</h1>
                    <p className={largeTextLight}>{projectData.hero.subtitle}</p>
                </div>
                <div className={heroCtaContainer}>
                    <div className={heroButtonsContainer}>
                        <button 
                            className={primaryButton}
                            onClick={() => handleSectionClick("offer")}
                        >
                            <span className={primaryButtonText}>{projectData.hero.primaryCta}</span>
                        </button>
                        <p className={smallTextLight}>{projectData.hero.offer_snippet}</p>
                    </div>
                </div>
            </div>
        </motion.div>
    );

};

export default Hero;
